import React from "react";

import { Route, Routes } from "react-router-dom";

import ContentLayout from "Components/ContentLayout";
import useSelectorWithUrlParams from "Hooks/useSelectorWithUrlParams";
import { gitProjectSelector } from "Reducers/project/project";

import DomainItem from "./containers/DomainItem";
import DomainNew from "./containers/DomainNew";
import DomainsList from "./containers/DomainsList";

const DomainsRoutes = () => {
  const project = useSelectorWithUrlParams(gitProjectSelector);

  return (
    <ContentLayout>
      <Routes>
        <Route path="-/new" element={<DomainNew project={project} />} />
        <Route path=":domainId" element={<DomainItem project={project} />} />
        <Route path="" element={<DomainsList project={project} />} />
      </Routes>
    </ContentLayout>
  );
};

export default DomainsRoutes;
